import React from 'react';
import classNames from 'classnames';
import get from 'lodash/get';

import ListItem from 'rebook/apps/base/components/ListItem';
import TagLabel from 'rebook/apps/base/components/TagLabel';
import { Genre, Tag, Actor } from 'rebook/apps/catalog/models';

import styles from './style.scss';


const BookGenresThemes = ({ book, user, extraClassName, maxTagsSize }) => {
  const genres = book.genres && book.genres.map((item) => {
    const genre = new Genre(item);

    return (
      <ListItem
        extraClassName={styles.listItem}
        key={genre.id}
        link={genre.getLink()}>
        <TagLabel maxWidth={maxTagsSize} name={genre.name} />
      </ListItem>
    );
  });

  const tags = book.tags && book.tags.map((item) => {
    const tag = new Tag(item);

    return (
      <ListItem
        extraClassName={styles.listItem}
        key={tag.id}
        link={tag.getLink()}>
        <TagLabel maxWidth={maxTagsSize} name={tag.name} />
      </ListItem>
    );
  });
  const actorTag = (actor) => {
    if (!actor) {
      return null;
    }

    const theActor = new Actor(actor);

    return (
      <ListItem
        extraClassName={styles.listItem}
        key={actor.id}
        link={theActor.getLink()}>
        <TagLabel withoutBorder maxWidth={maxTagsSize} name={actor.cover_name} />
      </ListItem>
    );
  };

  // dont render the component if we have only a part of the book object
  if (!genres && !book.annotation && !tags) {
    return null;
  }

  const isForAnonymous = !user;
  const isUnavailable = !book.available && !book.available_for_user;
  const actor = book.main_actor;
  const isAudioBook = book.type === 'audio';

  return (
    <div className={
      classNames(styles.genresThemes, extraClassName, { isUnavailable }, { isForAnonymous }, { isAudioBook })}>
      {get(actor, 'cover_name', null) && (
        <div className={classNames(styles.genresThemesSection, 'jest-actor-tag-link')}>
          <h3>Чтец</h3>
          <ul className={styles.itemList}>
            {actorTag(actor)}
          </ul>
        </div>
      )}
      {genres.length > 0 && (
        <div className={styles.genresThemesSection}>
          <h3>Жанры</h3>
          <ul className={styles.itemList}>
            {genres}
          </ul>
        </div>
      )}
      {tags.length > 0 && (
        <div className={styles.genresThemesSection}>
          <h3>Темы</h3>
          <ul className={styles.itemList}>
            {tags}
          </ul>
        </div>
      )}
    </div>
  );
};

export default BookGenresThemes;
